import { rankingItems } from '@/mocks/homeData';

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          热门榜单
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10">
          实时热度排行，发现大家都在看的好片
        </p>

        <div className="max-w-2xl mx-auto bg-background-50 border border-background-200/40 rounded-xl overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.title}
              className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100/50 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/30' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-foreground-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-950' :
                item.rank === 3 ? 'bg-secondary-500 text-foreground-50' :
                'bg-background-200 text-foreground-400'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-foreground-100 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.category}</p>
              </div>

              <div className="flex items-center gap-2 shrink-0">
                {item.trend === 'up' && (
                  <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                )}
                {item.trend === 'down' && (
                  <i className="ri-arrow-down-line text-secondary-500 text-sm"></i>
                )}
                {item.trend === 'stable' && (
                  <i className="ri-subtract-line text-foreground-500 text-sm"></i>
                )}
                <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.hot}</span>
              </div>

              <div className="w-8 h-8 flex items-center justify-center shrink-0 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-play-circle-line text-xl"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}